import { pick } from './rng';

export type RoomType = 'combat' | 'loot' | 'extraction' | 'event';

export type Room = {
  index: number;
  type: RoomType;
  seed: number;
};

export type RunLayout = {
  rooms: Room[];
};

const MID_POOL: ReadonlyArray<RoomType> = ['combat', 'combat', 'combat', 'loot', 'event'];

export function generateRunLayout(input: {
  rng: () => number;
  roomCount: number;
}): RunLayout {
  if (input.roomCount < 2) {
    throw new Error('generateRunLayout: roomCount must be >= 2');
  }

  const rooms: Room[] = [];

  rooms.push({ index: 0, type: 'combat', seed: Math.floor(input.rng() * 1e9) });

  for (let i = 1; i < input.roomCount - 1; i++) {
    const isPenultimate = i === input.roomCount - 2;
    rooms.push({
      index: i,
      type: isPenultimate ? 'combat' : pick(input.rng, MID_POOL),
      seed: Math.floor(input.rng() * 1e9),
    });
  }

  rooms.push({
    index: input.roomCount - 1,
    type: 'extraction',
    seed: Math.floor(input.rng() * 1e9),
  });

  return { rooms };
}
